$(document).ready(function () {
  // $("#tabs").tabs();
  
    // $('.pet_artwork_product').slick({
    //   dots: false,
    //   infinite: true,
    //   speed: 300,
    //   slidesToShow: 5,
    //   slidesToScroll: 5,
    //   arrows: true, 
    //   responsive: [
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         slidesToShow: 3,
    //         slidesToScroll: 3
    //       }
    //     },
    //     {
    //       breakpoint: 480,
    //       settings: {
    //         slidesToShow: 3,
    //         slidesToScroll: 3
    //       }
    //     }
    //   ]
    // });
    
  
    // var $carousel = $('.artwork_product');
    // $('.slider-nav').slick({
    //   slidesToShow: 4,
    //   slidesToScroll: 1,
    //   asNavFor: '.slider-for',
    //   dots: false,
    //   centerMode: false,
    //   focusOnSelect: true,
    //   variableWidth: true,
    //   arrows: false
    // });
  
    // get the selected font on load and on change 
    var fontID = document.querySelector('.sub-product-container .product-form__input [name="fontid"]');
  
    var previewTextSelector = document.querySelector('.window-lines-container');
    // get active font on load and style to the preview text
    // var activeFont = document.querySelector('.font-scroll .artwork_font.active');
    // var fontName = activeFont.getAttribute('data-font');
    // var fontLetterSpacing = activeFont.getAttribute('data-letterspacing');
    // var fontStyle = activeFont.getAttribute('data-fontstyle');
    // var selectedFont = activeFont.getAttribute('value');
    if (previewTextSelector != null) {
     // previewTextSelector.style.fontFamily = fontName;
      // previewTextSelector.style.letterSpacing = parseInt(fontLetterSpacing) + 'px';
      // previewTextSelector.style.fontStyle = fontStyle;
    }
    // document.querySelector('.selected-font').value = selectedFont;
  
    // change the active class on click of font change
    var el = document.querySelectorAll('.sub-product-container .font-scroll .artwork_font');
    for (let i = 0; i < el.length; i++) {
      el[i].onclick = function() {
        var c = 0;
        while (c < el.length) {
          el[c++].className = 'artwork_font';
        }
        el[i].className = 'artwork_font active';
        var fontName = el[i].getAttribute('data-font');
        var fontLetterSpacing = el[i].getAttribute('data-letterspacing');
        var fontStyle = el[i].getAttribute('data-fontstyle');
        var selectedFont = el[i].getAttribute('value');
        if (previewTextSelector != null) {
          previewTextSelector.style.fontFamily = fontName;
          previewTextSelector.style.letterSpacing = fontLetterSpacing + 'px';
          previewTextSelector.style.fontStyle = fontStyle;
        }
        document.querySelector('.selected-font').value = selectedFont;
      };
    }
  
  
    // Array.from(document.querySelectorAll('.sub-product-container .product-form__input [name="fontid"]')).forEach(function (select_box) {
    //   var selectID = select_box.getAttribute('id');
    //   var selectBoxs = document.getElementById(selectID);
    //   var fontName = selectBoxs.options[selectBoxs.selectedIndex].getAttribute('data-font');
    //   var fontLetterSpacing = selectBoxs.options[selectBoxs.selectedIndex].getAttribute('data-letterspacing');
    //   var fontStyle = selectBoxs.options[selectBoxs.selectedIndex].getAttribute('data-fontstyle');
    //   previewTextSelector.style.fontFamily = fontName;
    //   previewTextSelector.style.letterSpacing = fontLetterSpacing + 'px';
    //   previewTextSelector.style.fontStyle = fontStyle;
    // });
  
    // fontID.addEventListener('change', function(e) {
    //   Array.from(document.querySelectorAll('.sub-product-container .product-form__input [name="fontid"]')).forEach(function (select_box) {
    //     var selectID = select_box.getAttribute('id');
    //     var selectBoxs = document.getElementById(selectID);
    //     var fontName = selectBoxs.options[selectBoxs.selectedIndex].getAttribute('data-font');
    //     var fontLetterSpacing = selectBoxs.options[selectBoxs.selectedIndex].getAttribute('data-letterspacing');
    //     var fontStyle = selectBoxs.options[selectBoxs.selectedIndex].getAttribute('data-fontstyle');
    //     previewTextSelector.style.fontFamily = fontName;
    //     previewTextSelector.style.letterSpacing = fontLetterSpacing + 'px';
    //     previewTextSelector.style.fontStyle = fontStyle;
    //   });
    // });
  
    // engraving text field preview functionality
    var lineNumber, lineText;
    $(".engraving_input").keyup(function () {
      lineNumber = $(this).attr('data-input-line');
      lineText = $(this).val();
      var charCount = $(this).val().length;
      $(this).parent().find('.used_max_limit_char').text(charCount);
      var charlimit = $(`.window-lines-number[data-line-number="${lineNumber}"]`).text(lineText);
    });
  
    
  
  });
  
  class EngravingProductForm extends HTMLElement {
  
    constructor() {
      super();   
  
      this.form = this.querySelector('form');
      // console.log(this.form, '======>form');
      this.querySelector('[data-action="add-to-cart"]').addEventListener('click',this._addToCart.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }
  
    _addToCart(event) {
      event.preventDefault(); // Prevent form to be submitted
      console.log('dfdsfffffffffffffffff');
      const addoncheck = document.querySelector('#check-pro');
      var _this4 = this;
      Shopify.queue = [];
      const properties = {};
      let randomNo = Math.floor(Math.random() * 10000);
      var myElem = document.querySelector('.engraving-product-form');
      var addToCartButton = this.querySelector('.product_engraving_add'); // First, we switch the status of the button
      addToCartButton.setAttribute('disabled', true);
      addToCartButton.classList.add('loading');
      var cartNoti = this.cartNotification;
      cartNoti.setActiveElement(document.activeElement);
      var cartNotificationSection = cartNoti.getSectionsToRender().map((section) => section.id);
  
      // get the selected personalized product variant ID and art work image products variant ID
      var defaultSelectedVariantId = document.querySelector('.sub-product-container .product-form__input [name="id"]').value;
      console.log(defaultSelectedVariantId, '=======>defaultSelectedVariantId');

      var funeralProducts = document.querySelector('input[name="funralproduct"]:checked');
      var petProducts = document.querySelector('input[name="petproduct"]:checked');
      console.log(funeralProducts, '======>funeralProducts');
      console.log(petProducts, '=======>petProducts');

      if (funeralProducts != null) {
        var selectedFuneralProducts = funeralProducts.getAttribute('data-variant-id');
      }

      if (petProducts != null) {
        var selectedPetProducts = petProducts.getAttribute('data-variant-id');
      }
      console.log(selectedFuneralProducts, '====>selectedFuneralProducts');
      console.log(selectedPetProducts, '====>selectedPetProducts');


      var artWorkImageSelector = document.querySelector(".artwork-image-option-select");
      if (artWorkImageSelector != null) {
        var artWorkImageSelect = artWorkImageSelector.value;
      }
  
      var formElement = this.querySelector('.engraving_form');
      var formSerialize = JSON.parse(serializeForm(formElement));
      var variantId = formSerialize.id;
      var quantity = document.querySelector('.engraving__quantity__input').value;
  
      if (myElem !== null) {
        properties._random_no = randomNo;
      }
  
      // Pass all properties from product to the cart line items
      Array.from(formElement.querySelectorAll('[name*="properties"]')).forEach(function(prop) {
        const name = prop.name.replace('properties[', '').replace(']', '');
        properties[name] = prop.value;
      });
  
      // get selected engraving product variant id and push it in the shopify queue
      if (defaultSelectedVariantId != null ) {
        const defaultEngravingProduct = {};
        defaultEngravingProduct._random_no = randomNo;
        defaultEngravingProduct._type = 'Engraving Product';
        Shopify.queue.push({
          variantId: defaultSelectedVariantId,
          properties: defaultEngravingProduct,
          quantity,
        });
      }
  
      // get selected engraving artwork image product variant id and push it in the shopify queue
      if (artWorkImageSelector != null ) {
        if (artWorkImageSelect != 'Choose Image') {
          const defaultArtWorkProduct = {};
          defaultArtWorkProduct._random_no = randomNo;
          defaultArtWorkProduct._type = 'ArtWork Product';
          Shopify.queue.push({
            variantId: artWorkImageSelect,
            properties: defaultArtWorkProduct,
            quantity,
          });
        }
      }

      // get selected funreal artwork product variant id and push it in the shopify queue
      if (selectedFuneralProducts != null || selectedFuneralProducts != undefined) {
        const defaultFunrealProduct = {};
        defaultFunrealProduct._random_no = randomNo;
        defaultFunrealProduct._type = 'Engraving Product';
        Shopify.queue.push({
          variantId: selectedFuneralProducts,
          properties: defaultFunrealProduct,
          quantity,
        });
      }

      // get selected pet artwork product variant id and push it in the shopify queue
      if (selectedPetProducts != null || selectedPetProducts != undefined ) {
        const defaultPetProduct = {};
        defaultPetProduct._random_no = randomNo;
        defaultPetProduct._type = 'Engraving Product';
        Shopify.queue.push({
          variantId: selectedPetProducts,
          properties: defaultPetProduct,
          quantity,
        });
      }
      
      Shopify.queue.push({
        variantId,
        properties,
        quantity,
      });

      console.log(Shopify.queue, '=======>queue');
  
      Shopify.moveAlong = function() {
        if (Shopify.queue.length) {
          console.log('in if');
          const request = Shopify.queue.shift();        
          const body = JSON.stringify({form_type: 'product', id: request.variantId, properties: request.properties, quantity: request.quantity,
          sections: cartNotificationSection,
          sections_url: window.location.pathname});
  
          fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body }).then(function (response) {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            var quantityElement = formElement.querySelector('[name="quantity"]');
            console.log(response,"respondserespondserespondserespondserespondserespondserespondserespondserespondserespondse");
            if (response.ok) {
              response.json().then(function (content) {
                cartNoti.renderContents(content);
              });
              addToCartButton.classList.remove('loading');
              addToCartButton.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render
                  console.log("=======-=-=-=-=-=--=");
              _this4.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: _this4.currentVariant,
                  quantity: quantityElement ? parseInt(quantityElement.value) : 1
                }
              }));
              Shopify.moveAlong();
            } else {
              response.json().then(function (content) {
                var errorMessageElement = document.createElement('span');
                errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
                errorMessageElement.innerHTML = content['description'];
                addToCartButton.removeAttribute('disabled');
                addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
                addToCartButton.classList.remove('loading');
                setTimeout(function () {
                  errorMessageElement.remove();
                }, 2500);
              });
            }
          });
        }else {
          console.log('in else');
          // clear the form and close the form
          // document.getElementById("check-pro").checked = false;
          addToCartButton.setAttribute('disabled', true);
          addToCartButton.classList.remove('loading');
          // var ArtworkOption = document.querySelector('variant-selects-addon [name="options[Artwork]"]');
          // ArtworkOption.selectedIndex = 0;
          // document.querySelector('.artwork_product_image').classList.add('hidden');
          // document.querySelector('.artwork_image_variant').classList.remove('hidden');
          // // ArtworkOption.remove(ArtworkOption.selectedIndex);
          
          // var ArtWorkImage = document.querySelector('.sub-product-container .product-form__input [name="artimageid"]');
          // ArtWorkImage.selectedIndex = 0;
          // document.querySelector('.artwork-product-wrapper').classList.remove('hidden');
          // document.querySelector('.artwork-image-prices').innerHTML = '$0.00';
          // document.querySelector('.artwork_product_image').setAttribute('src','');

          var allInputs = document.querySelectorAll('.engraving-input-containers input');
          allInputs.forEach(singleInput => singleInput.value = '');
          var linenumber = document.querySelectorAll('.window-lines-number');
          linenumber.forEach(singleLine => singleLine.innerHTML  = '');
          var pagebutton= document.getElementById("ModalClose-engraving");
          if (pagebutton != null) {
            pagebutton.click();
          }
          // document.getElementById("form1").reset();
        }
      };
      Shopify.moveAlong();
  
    }
  
  }
  
  customElements.define('engraving-product-form', EngravingProductForm);
  


  //  custom js functions
  const engravebtnEle = document.querySelector('.addengraving-btn');
  const engraveWrapperEle = document.querySelector('.engraving-wrapper__main-container');
  const engraveCheckboxR = document.querySelector('.form-group');
  

  engravebtnEle?.addEventListener('click', () => {
  if (engraveWrapperEle) {
    if (engraveWrapperEle.style.maxHeight === '0px' || engraveWrapperEle.style.maxHeight === '') {
      engraveWrapperEle.style.maxHeight = 'max-content';
      // engraveWrapperEle.style.maxHeight = '1710px';
    } else {
      engraveWrapperEle.style.maxHeight = '0px';
    }
  }
  if (engraveCheckboxR) {
    engraveCheckboxR.classList.toggle('active');
  }
});


  
  



